import { defineComponent as _defineComponent } from 'vue'
import {useToast} from "vue-toastification";
import {computed, ref, watch} from "vue";
import {AddressType} from "@/components/buyTokens/modals/AddressType";
import {useUserServiceStore} from "@/store/userService.store";
import Dialog from "primevue/dialog";
import {useRouter} from "vue-router";
import { X } from 'lucide-vue-next';
import {usePublicSalesStore} from "@/store/publicSales.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvideAddresInfoModal',
  props: {
    addressType: { type: String, required: true },
    display: { type: Boolean, required: true },
    address: { type: String, required: true }
  },
  emits: ['close', 'confirm'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const toast = useToast();
const router = useRouter();

const props = __props;

const show = ref(false);
watch(() => props.display, (newVal, _) => {
  show.value = newVal;
});

const usersEmail = computed(() => {
  return useUserServiceStore().getUserEmail;
});

const emit = __emit;

const warning = computed(() => {
  return usePublicSalesStore().getWarning;
});


function confirm(){
  emit('confirm');
}

const addressType = () => {
  if(props.addressType == AddressType.KEPLR) {
    return 'Claimer';
  } else {
    return 'Source';
  }
};
const getAddressType = () => {
  if(props.addressType == AddressType.KEPLR) {
    return 'C4E';
  } else {
    return 'Ethereum';
  }
};

const __returned__ = { toast, router, props, show, usersEmail, emit, warning, confirm, addressType, getAddressType, get AddressType() { return AddressType }, get Dialog() { return Dialog }, get X() { return X }, get usePublicSalesStore() { return usePublicSalesStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})